<div class="page-body">
  <div class="row">
    <div class="col-sm-12">
      <app-card [title]="'global.archive'|translate">
        <app-grid [grid]="grid"></app-grid>
        <button class="btn btn-primary ripple light pull-right my-3" (click)="goToProductOverview()"
                type="button">{{'admin.product.overview.button'|translate}}</button>
      </app-card>
    </div>
  </div>
</div>
<ng-template #priceTemp let-row="row" let-value="value" let-column="column">
  {{((row.dealerPrice) ? row.dealerPrice : row.customerPrice)| BackofficeCurrency}}
</ng-template>
<ng-template #customerPriceTemp let-row="row" let-value="value" let-column="column">
  {{row.customerPrice| BackofficeCurrency}}
</ng-template>

<app-modal-basic #readdModal>
  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'global.soft_readd_title' | translate:{entity: 'Product'} }}</h4>
    <button type="button" class="close basic-close" (click)="readdModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p>{{ 'global.soft_readd_body' | translate}}: <span [innerHTML]="productName"></span> ?</p>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4"
            (click)="readdModal.hide()">{{'global.cancel'|translate}}</button>
    <button type="button" class="btn btn-primary ripple light"
            (click)="readd()">{{'global.actions.readd'|translate}}</button>
  </div>
</app-modal-basic>

